import { ServiceDto } from "../../../../../Api/Model/ServiceDto.csharp";

export const serviceInitialState: ServiceDto = {
  id: "",
  name: "",
  description: "",
  specializationId: "",
  availableForOnlineBooking: true,
  centerBookingOptions: [],
  noOnlineBookingInfo: "",
  pricingName: "",
  bookingName: "",
  disableCenterAlert: false,
  enableVideoTelephoneOption: false,
  forcedOffline: false,
  keywords: [],
  serviceUrl: "",
  disableDoctorSelection: false,
  priceDetailsLabel: "",
  disablePriceDetails: false,
  showDoctorsJobTitle: false,
  serviceGroupId: "",
  isGroup: false,
  sortIndex: 0,
  bookingGroupName: "",
  disableOptionalCampaignHighlight: false,
  disableDoctorPageListing: false,
  newBookingQuickServiceName: ""
};
